var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiersWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160689",
    "data-name": "Group 160689",
    transform: "translate(-136 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1340",
    "data-name": "Rectangle 1340",
    width: 18,
    height: 18,
    transform: "translate(136 216)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160626",
    "data-name": "Group 160626",
    transform: "translate(137.37 216.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160606",
    "data-name": "Group 160606"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 0.45,
    cy: 0.45,
    r: 0.45,
    transform: "translate(7.257 13.098)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M9.53,11.878l-6.6-4.631a.644.644,0,0,1,0-1.128l6.6-4.631a1.508,1.508,0,0,1,1.6,0l6.61,4.631a.644.644,0,0,1,0,1.128l-6.61,4.631A1.508,1.508,0,0,1,9.53,11.878Z",
    transform: "translate(-2.571 -1.257)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M4.193,12.841l-1.278-.931a.658.658,0,0,1,0-1.128L4.232,9.82",
    transform: "translate(-2.571 -3.065)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 4.339,
    y1: 3.164,
    transform: "translate(1.621 9.776)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M18.334,9.94l1.183.86a.658.658,0,0,1,0,1.128L13.9,16.03",
    transform: "translate(-4.332 -3.09)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M16.529,13.54l1.192.836a.644.644,0,0,1,0,1.128l-6.61,4.631a1.508,1.508,0,0,1-1.6,0L2.9,15.5a.644.644,0,0,1,0-1.128l1.069-.749",
    transform: "translate(-2.565 -3.85)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.33
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiersWhiteIcon);
export default __webpack_public_path__ + "static/media/tiers-white-icon.f13e860155e42e4b0ac7a4c4705c48a4.svg";
export { ForwardRef as ReactComponent };